"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slateToHtml = void 0;
const types_1 = require("../types");
const lodash_1 = __importDefault(require("lodash"));
const guards_1 = require("../types/guards");
const objToStyle = (obj) => {
    return Object.entries(obj)
        .map(([key, value]) => `${key}: ${value}`)
        .join(';');
};
const getNodeAttribures = (node) => {
    const style = {};
    const attrs = {};
    if (node[types_1.SlateElementMark.textAlign]) {
        style['text-align'] = node[types_1.SlateElementMark.textAlign];
    }
    if (node[types_1.SlateMark.bold]) {
        style['font-weight'] = 'bold';
    }
    if (node[types_1.SlateMark.italic]) {
        style['font-style'] = 'italic';
    }
    if (node[types_1.SlateMark.underline]) {
        style['text-decoration'] = 'underline';
    }
    if (node[types_1.SlateMark.strikethrough]) {
        style['text-decoration'] = 'line-through';
    }
    if (node[types_1.SlateMark.backgroundColor]) {
        style['background-color'] = node[types_1.SlateMark.backgroundColor];
    }
    if (node[types_1.SlateMark.color]) {
        style.color = node[types_1.SlateMark.color];
    }
    if (node[types_1.SlateMark.textTransform]) {
        style['text-transform'] = node[types_1.SlateMark.textTransform];
    }
    if (node[types_1.SlateMark.register]) {
        switch (node[types_1.SlateMark.register]) {
            case 'capitalize':
                style['text-transform'] = 'capitalize';
                break;
            case 'lowercase':
                style['text-transform'] = 'lowercase';
                break;
        }
    }
    if (node.type === types_1.SlateElementType.link) {
        attrs.href = node.url;
    }
    return Object.assign(Object.assign({}, attrs), { style: objToStyle(style) });
};
const slateToHtml = (nodes) => {
    const result = nodes.map((node) => {
        const attr = getNodeAttribures(node);
        if ((0, guards_1.isBlockElement)(node)) {
            if (node.type === types_1.SlateElementType.elementDefault) {
                return `<p style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</p>`;
            }
            if (node.type === types_1.SlateElementType.blockquote) {
                return `<blockquote style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</blockquote>`;
            }
            if (node.type === types_1.SlateElementType.listItem) {
                return `<li style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</li>`;
            }
            if (node.type === types_1.SlateElementType.heading1) {
                return `<h1 style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</h1>`;
            }
            if (node.type === types_1.SlateElementType.heading2) {
                return `<h2 style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</h2>`;
            }
            if (node.type === types_1.SlateElementType.heading3) {
                return `<h3 style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</h3>`;
            }
            if (node.type === types_1.SlateElementType.heading4) {
                return `<h4 style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</h4>`;
            }
            if (node.type === types_1.SlateElementType.caption) {
                return `<div role="caption" style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</div>`;
            }
        }
        if ((0, guards_1.isListElement)(node)) {
            if (node.type === types_1.SlateElementType.numberedList) {
                return `<ol style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</ol>`;
            }
            if (node.type === types_1.SlateElementType.bulletedList) {
                return `<ul style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</ul>`;
            }
        }
        if ((0, guards_1.isInlineElement)(node)) {
            if (node.type === types_1.SlateElementType.link) {
                return `<a href="${attr.href}" style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</a>`;
            }
            if (node.type === types_1.SlateElementType.crossLink) {
                const crossLink = node;
                const href = `~/${crossLink.value.section}/${crossLink.value.block || ''}`;
                return `<a href="${href}" style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</a>`;
            }
            if (node.type === types_1.SlateElementType.code) {
                return `<code style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</code>`;
            }
            if (node.type === types_1.SlateElementType.annotation) {
                const annotation = node;
                return `<span style="${attr.style}" title="${annotation.value}"><span hidden>${annotation.value}</span>${(0, exports.slateToHtml)(node.children)}</span>`;
            }
            if (node.type === types_1.SlateElementType.mention) {
                const mention = node;
                const href = `@${mention.employeeId}`;
                return `<a href="${href}" style="${attr.style}">${(0, exports.slateToHtml)(node.children)}</a>`;
            }
        }
        if ((0, guards_1.isTextNode)(node)) {
            if (node[types_1.SlateMark.register] === 'sub') {
                return `<sub>${(0, exports.slateToHtml)([lodash_1.default.omit(node, types_1.SlateMark.register)])}</sub>`;
            }
            if (node[types_1.SlateMark.register] === 'sup') {
                return `<sup>${(0, exports.slateToHtml)([lodash_1.default.omit(node, types_1.SlateMark.register)])}</sup>`;
            }
            if (node[types_1.SlateMark.strikethrough]) {
                return `<span style="text-decoration: line-through">${(0, exports.slateToHtml)([lodash_1.default.omit(node, types_1.SlateMark.strikethrough)])}</span>`;
            }
            return `<span style="${attr.style}">${node.text}</span>`;
        }
        throw new Error(`Unknown node type: ${JSON.stringify(node, null, 2)}`);
    });
    return result.join('');
};
exports.slateToHtml = slateToHtml;
